import {weChatServerGetOpenId} from '../services/global'
import Vue from 'vue'

// 获取openId
async function getOpenId(code, fullPath){
    if(!sessionStorage.getItem('openId')) {
        if(!code) {
            let url = window.location.origin + fullPath
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe5b97b5df67f4500&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
            return
        } else {
            const params = {
                code: code
            }
            const response = await weChatServerGetOpenId(params)
            if(response.code == 10000) {
                Vue.prototype.$addStorageEvent('openId', response.result.openId)
            }
        }

    }
}
export default getOpenId